import { TRUST_AND_SECURITY_URL } from "constants/urls"
import Button from "components/ui/Button"
import CircleCheckList, { ListItem } from "components/ui/CircleCheckList"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

function SecurityFeaturesSection() {
  return (
    <Container section>
      <Heading
        label="Data Protection"
        title="Enterprise Security Built for Healthcare"
        subtitle="Preset implements comprehensive security controls to protect PHI and meet HIPAA requirements."
        decoration="border"
      />
      <div className="mt-12 grid gap-12 lg:grid-cols-2">
        <div>
          <h3 className="mb-6 text-2xl font-bold text-black">
            Technical Safeguards
          </h3>
          <CircleCheckList>
            <ListItem>Encryption for data in transit with TLS 1.2+</ListItem>
            <ListItem>AES-256 encryption for all data at rest</ListItem>
            <ListItem>
              Role-Based Access Controls (RBAC) for fine-grained permissions
            </ListItem>
            <ListItem>Row-level security for granular data access</ListItem>
            <ListItem>
              SSO/SAML integration with your identity provider
            </ListItem>
            <ListItem>Multi-factor authentication (MFA) enforcement</ListItem>
          </CircleCheckList>
        </div>
        <div>
          <h3 className="mb-6 text-2xl font-bold text-black">
            Administrative Safeguards
          </h3>
          <CircleCheckList>
            <ListItem>Business Associate Agreement (BAA) available</ListItem>
            <ListItem>Regular third-party penetration testing</ListItem>
            <ListItem>Continuous compliance monitoring with Vanta</ListItem>
            <ListItem>Comprehensive audit logging and monitoring</ListItem>
            <ListItem>Secure Software Development Lifecycle (SDLC)</ListItem>
            <ListItem>
              Employee security training and background checks
            </ListItem>
          </CircleCheckList>
        </div>
      </div>
      <Button
        className="mt-12"
        color="green"
        size="medium"
        href={TRUST_AND_SECURITY_URL}
        trackClick="View all security features_HIPAA Compliance"
        shadow
      >
        View All Security Features
      </Button>
    </Container>
  )
}

export default SecurityFeaturesSection
